import { useIntl } from 'react-intl';
import { Skeleton, Stack, Typography } from '@rossum/ui/material';

export type OriginalDocumentHeaderProps = {
  workspaceName?: string;
  queueName?: string;
  documentName?: string;
};

const Breadcrumb = ({
  workspaceName,
  queueName,
  documentName,
}: OriginalDocumentHeaderProps) => {
  if (!workspaceName && !queueName && !documentName) {
    return <Skeleton width={220} />;
  }

  const breadcrumb = [workspaceName, queueName, documentName]
    .filter(Boolean)
    .join(' > ');

  return (
    <Typography variant="caption" color="text.secondary">
      {breadcrumb}
    </Typography>
  );
};

export const OriginalDocumentHeader = ({
  workspaceName,
  queueName,
  documentName,
}: OriginalDocumentHeaderProps) => {
  const intl = useIntl();

  return (
    <Stack
      alignItems="flex-start"
      justifyContent="flex-end"
      spacing={0.5}
      sx={{ height: '100%', pb: 2 }}
    >
      <Typography variant="subtitle2" fontWeight={600} color="text.primary">
        {intl.formatMessage({
          id: 'features.documentSplit.canvas.originalDocumentTitle',
        })}
      </Typography>
      <Breadcrumb
        workspaceName={workspaceName}
        queueName={queueName}
        documentName={documentName}
      />
    </Stack>
  );
};
